var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import MessageModule from '../../mixins/MessageModule';
import { InvoiceData } from "../../../lib/invoiceData";
import { getAccountHttp } from "../../../lib/nisUtils";
import { Address, XEM } from "nem-library";
import { MUTATION_TYPES } from "../../../lib/mutationTypes";
import { getDivided } from "../../../lib/numberUtils";
export default Vue.extend({
    mixins: [MessageModule],
    name: "ScanView",
    props: {
        isActive: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onInit(promise) {
            return __awaiter(this, void 0, void 0, function* () {
                // show loading indicator
                try {
                    yield promise;
                    // successfully initialized
                }
                catch (error) {
                    let message = 'Unknown';
                    if (error.name === 'NotAllowedError') {
                        // user denied camera access permisson
                        message = 'Not Allowed';
                    }
                    else if (error.name === 'NotFoundError') {
                        // no suitable camera device installed
                        message = 'Not Found';
                    }
                    else if (error.name === 'NotSupportedError') {
                        // page is not served over HTTPS (or localhost)
                        message = 'Not Supported';
                    }
                    else if (error.name === 'NotReadableError') {
                        // maybe camera is already in use
                        message = 'Not Readable';
                    }
                    else if (error.name === 'OverconstrainedError') {
                        // passed constraints don't match any camera. Did you requested the front camera although there is none?
                        message = 'Over Constrained';
                    }
                    else {
                        // browser is probably lacking features (WebRTC, Canvas)
                        message = 'Unknown';
                    }
                    this.showError('Camera is not available: ' + message);
                }
                finally {
                    // hide loading indicator
                }
            });
        },
        onDecode(decodedString) {
            const invoiceData = InvoiceData.fromJsonString(decodedString);
            if (invoiceData) {
                const accountHttp = getAccountHttp();
                let address = new Address(invoiceData.address);
                this.$store.commit(MUTATION_TYPES.SET_RECEIVER_ADDRESS, invoiceData.address);
                this.$store.commit(MUTATION_TYPES.CLEAR_SEND_MOSAIC);
                this.$store.commit(MUTATION_TYPES.ADD_SEND_MOSAIC, new XEM(getDivided(invoiceData.amount, 6).toNumber()));
                this.$store.commit(MUTATION_TYPES.SET_MESSAGE_ENCRYPTION, false);
                this.$store.commit(MUTATION_TYPES.SET_SEND_MESSAGE, invoiceData.message);
                accountHttp.getFromAddress(address).subscribe(accountInfoWithMetaData => {
                    if (accountInfoWithMetaData.publicAccount.hasPublicKey()) {
                        // store public key for message encryption
                        this.$store.commit(MUTATION_TYPES.SET_RECEIVER_PUBLIC_KEY, accountInfoWithMetaData.publicAccount.publicKey);
                    }
                    else {
                        this.$store.commit(MUTATION_TYPES.SET_RECEIVER_PUBLIC_KEY, '');
                    }
                    if (invoiceData.type === 1) {
                        // type 1 is address only jump to amount setting
                        this.$router.push('/send/amount');
                    }
                    else {
                        this.$router.push('/send/confirmation');
                    }
                }, error => {
                    this.$store.commit(MUTATION_TYPES.SET_RECEIVER_PUBLIC_KEY, '');
                    this.$router.push('/send/confirmation');
                });
            }
        }
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/top/Scan.vue
// module id = 605
// module chunks = 1